import api from '@/utils/api';
import {
    SUMMARY_STATISTICS,
    REVENUE_STATISTICS,
    STAFF_REVENUE_YEARLY,
    STAFF_REVENUE_DETAIL,
    STAFF_REVENUE_YEARLY_EXPORT_EXCEL,
    STAFF_REVENUE_DETAIL_EXPORT_EXCEL,
    STAFF_INCOME_DETAIL,
    ASSISTANTS_SUPPORT_CASE_EXPORT_EXCEL,
    GET_ASSISTANTS_SUPPORT_CASES,
    CUSTOMER_VISIT_STATISTICS,
    ASSISTANTS_SUPPORT_CASE_EXPORT_ALL_EXCEL
} from './types';
import { NotificationManager } from 'react-notifications';

export const getSummaryStatistics = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/statistics', { params: filter }).then(res => {
            dispatch({ type: SUMMARY_STATISTICS, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getRevenueStatistics = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/statistics/revenue', { params: filter }).then(res => {
            dispatch({ type: REVENUE_STATISTICS, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

/**
 * ⭐ Thống kê doanh số nhân viên theo năm
 * API: GET /statistics/staff-revenue-yearly
 * params: { year }
 */
export const getStaffRevenueYearly = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/statistics/staff-revenue-yearly', { params: filter })
            .then(res => {
                dispatch({ type: STAFF_REVENUE_YEARLY, payload: res.data });
                resolve(res.data);
            })
            .catch(err => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg || 'Lỗi thống kê theo năm');
                reject(err);
            });
    });
};

export const getStaffRevenueDetail = (filter = {}) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/statistics/staff-revenue-detail', { params: filter })
            .then(res => {
                dispatch({
                    type: STAFF_REVENUE_DETAIL,
                    payload: res.data || {}
                });
                resolve(res.data || {});
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Lỗi thống kê doanh số nhân viên chi tiết'
                );
                reject(err);
            });
    });
};

// Xuất excel thống kê doanh số nhân viên theo năm
export const staffRevenueYearlyExportExcel = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/statistics/staff-revenue-yearly/export`, filter).then(res => {
            dispatch({ type: STAFF_REVENUE_YEARLY_EXPORT_EXCEL, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            console.log(err.response);
            NotificationManager.error(err.response.data.msg);
            reject(err);
        });
    })
}

// Xuất excel thống kê doanh số nhân viên chi tiết
export const staffRevenueDetailExportExcel = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/statistics/staff-revenue-detail/export`, filter).then(res => {
            dispatch({ type: STAFF_REVENUE_DETAIL_EXPORT_EXCEL, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            console.log(err.response);
            NotificationManager.error(err.response.data.msg);
            reject(err);
        });
    })
}

// Thống kê số ca phụ của phụ tá
export const getAssistantsSupportCases = (filter = {}) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/statistics/assistants/support-cases', { params: filter })
            .then(res => {

                console.log("resss", res)
                dispatch({
                    type: GET_ASSISTANTS_SUPPORT_CASES,
                    payload: res.data || {}
                });
                resolve(res.data || {});
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Lỗi thống kê doanh số nhân viên chi tiết'
                );
                reject(err);
            });
    });
};

// Xuất excel thống kế số ca phụ của phụ tá
export const assistantsSupportCaseExportExcel = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/statistics/assistants/support-cases/export`, filter).then(res => {
            dispatch({ type: ASSISTANTS_SUPPORT_CASE_EXPORT_EXCEL, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            console.log(err.response);
            NotificationManager.error(err.response.data.msg);
            reject(err);
        });
    })
}

// Xuất excel thống kê số ca phụ của toàn bộ phụ tá
export const assistantsSupportCaseExportAllExcel = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/statistics/assistants/support-cases/export-all`, filter).then(res => {
            dispatch({
                type: ASSISTANTS_SUPPORT_CASE_EXPORT_ALL_EXCEL,
                payload: res.data.data
            });
            resolve(res.data.data);
        }).catch(err => {
            console.log(err.response);
            NotificationManager.error(err.response?.data?.msg || 'Xuất file thất bại');
            reject(err);
        });
    });
};


// Thống kê lượt khách hàng đến theo nhóm dịch vụ
export const customerVisitStatistics = (filter = {}) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/statistics/customer-visits', { params: filter })
            .then(res => {

                console.log("resss", res)
                dispatch({
                    type: CUSTOMER_VISIT_STATISTICS,
                    payload: res.data || {}
                });
                resolve(res.data || {});
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Lỗi thống kê lượt khách hàng đến theo nhóm dịch vụ'
                );
                reject(err);
            });
    });
};

export const getStaffIncomeDetail = (filter = {}) => dispatch => {
    return api.get('/statistics/staff-income-detail', { params: filter })
        .then(res => {
            dispatch({ type: STAFF_INCOME_DETAIL, payload: res.data || {} });
            return res.data || {};
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Lỗi báo cáo doanh thu nhân viên');
            throw err;
        });
};
